import { render, staticRenderFns } from "./ConcludedOrders.vue?vue&type=template&id=2325f066&scoped=true"
import script from "./ConcludedOrders.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConcludedOrders.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ConcludedOrders.vue?vue&type=style&index=0&id=2325f066&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325f066",
  null
  
)

export default component.exports